const u = (t, o) => {
  let e;
  return () => {
    clearTimeout(e), e = setTimeout(() => t(), o);
  };
};
export {
  u as debounce
};
